import { clients } from '@/lib/https';
import { API_BASES } from '@/constant/endpoint.constant';
import { AI_ENDPOINTS } from '@/modules/gpt-chats/constants/endpoint.constant';
import {
  IAddFilesPayload,
  IAddFilesResponse,
  IAddLinkPayload,
  IAddLinkResponse,
  IAddQnAPayload,
  IAddQnAResponse,
  IAddTextPayload,
  IAddTextResponse,
  ICreateFolderPayload,
  ICreateFolderResponse,
  IDeleteFolderPayload,
  IDeleteFolderResponse,
  IDeleteKbByIdPayload,
  IDeleteKbByIdResponse,
  IGetAllKBPayload,
  IGetAllKBResponse,
  IGetFolderListResponse,
  IReembedKbPayload,
  IReembedKbResponse,
  IUpdateFolderPayload,
  IUpdateFolderResponse,
  IUpdateKbPayload,
  IUpdateKbResponse,
  IGetAgentsByFolderIdPayload,
  IGetAgentsByFolderIdResponse,
} from '../types/kb.service.type';

export class KBService {
  getAllKB(payload: IGetAllKBPayload): Promise<IGetAllKBResponse> {
    return clients.post(`${API_BASES.AI}${AI_ENDPOINTS.KB_KNOWLEDGES}`, JSON.stringify(payload));
  }

  addText(payload: IAddTextPayload): Promise<IAddTextResponse> {
    return clients.post(`${API_BASES.AI}${AI_ENDPOINTS.KB_TEXT}`, JSON.stringify(payload));
  }

  addLink(payload: IAddLinkPayload): Promise<IAddLinkResponse> {
    return clients.post(`${API_BASES.AI}${AI_ENDPOINTS.KB_LINK}`, JSON.stringify(payload));
  }

  addQnA(payload: IAddQnAPayload): Promise<IAddQnAResponse> {
    return clients.post(`${API_BASES.AI}${AI_ENDPOINTS.KB_QA}`, JSON.stringify(payload));
  }

  addfiles(payload: IAddFilesPayload): Promise<IAddFilesResponse> {
    return clients.post(`${API_BASES.AI}${AI_ENDPOINTS.KB_FILE}`, JSON.stringify(payload));
  }

  updateKb(payload: IUpdateKbPayload): Promise<IUpdateKbResponse> {
    return clients.post(`${API_BASES.AI}${AI_ENDPOINTS.KB_UPDATE}`, JSON.stringify(payload));
  }

  deleteKbById(payload: IDeleteKbByIdPayload): Promise<IDeleteKbByIdResponse> {
    return clients.delete(`${API_BASES.AI}${AI_ENDPOINTS.KB_DELETE.replace(':id', payload.kb_id)}`);
  }

  reembedKb(payload: IReembedKbPayload): Promise<IReembedKbResponse> {
    return clients.post(`${API_BASES.AI}${AI_ENDPOINTS.KB_REEMBED}`, JSON.stringify(payload));
  }

  createFolder(payload: ICreateFolderPayload): Promise<ICreateFolderResponse> {
    return clients.post(`${API_BASES.AI}${AI_ENDPOINTS.KB_FOLDER_CREATE}`, JSON.stringify(payload));
  }

  updateFolder(payload: IUpdateFolderPayload): Promise<IUpdateFolderResponse> {
    return clients.put(`${API_BASES.AI}${AI_ENDPOINTS.KB_FOLDER_UPDATE}`, JSON.stringify(payload));
  }

  getFolderList(): Promise<IGetFolderListResponse> {
    return clients.get(`${API_BASES.AI}${AI_ENDPOINTS.KB_FOLDER_LIST}`);
  }

  deleteFolder(payload: IDeleteFolderPayload): Promise<IDeleteFolderResponse> {
    return clients.delete(
      `${API_BASES.AI}${AI_ENDPOINTS.KB_FOLDER_DELETE}?folder_id=${payload.folder_id}`
    );
  }

  getAgentsByFolderId(payload: IGetAgentsByFolderIdPayload): Promise<IGetAgentsByFolderIdResponse> {
    return clients.get(
      `${API_BASES.AI}${AI_ENDPOINTS.KB_FOLDER_AGENTS}?folder_id=${payload.folder_id}`
    );
  }
}
export const kbService = new KBService();
